import React from 'react';
import { Button } from './ui/Button';
interface OfferPackage {
  id: string;
  name: string;
  subtitle: string;
  description: string;
  price: string;
  image: string;
}
const packages: OfferPackage[] = [{
  id: 'andromeda',
  name: 'Andromeda',
  subtitle: 'Nosečniška fotografija',
  description: 'Nežna, intimna in čustvena fotografija, ki slavi novo življenje. Vključuje fotografijo na lokaciji ali studiju, vodenje poziranja, obdelava fotografij. Primerno za bodoče mamice, pare ali uresničevanje želje po nosečniških portretih. (slika je simbolična zaradi zasebnosti strank)',
  price: '300€',
  image: 'https://images.unsplash.com/photo-1544126592-807ade215a0b?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 'milky-way',
  name: 'Milky Way',
  subtitle: 'Družinska fotografija',
  description: 'Topli, sproščeni in pristni družinski trenutki. Vključuje fotografiranje družin v naravno ujetih trenutkih ali kot studijsko fotografiranje. Okolje je lahko studio ali željeni kraj ali kar dom. Popolna izbira za družinske spomine, praznike, krste ali posebna življenska obdobja.',
  price: '300€',
  image: 'https://images.unsplash.com/photo-1609220136736-443140cffec6?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 'orion',
  name: 'Orion',
  subtitle: 'Portreti',
  description: 'Portreti z značajem. Osebni, poslovni ali umetniški. Vključuje individualno fotografijo ali parni portret. Prilagojen stil glede na željo stranke. Fotografiranje je možno v studiju ali na terenu. Paket je tudi namenjen, kjer stranka želi, da jo spremljam v nekem dogajanju. Slike so kasneje namenjene za objavo na družbenih omrežjih. Skozi fotografiranje vas vodim, stranka dobi profesionalno obdelane fotografije.',
  price: '350€',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2787&auto=format&fit=crop'
}, {
  id: 'pegasus',
  name: 'Pegasus',
  subtitle: 'Fotografija za spletne strani in blagovne znamke',
  description: 'Vizualna identiteta, ki govori namesto vas. Vključuje fotografiranje za podjetja, podjetnike in ustvarjalce. Lifestyle, delovni proces, portreti zaposlenih, prostori. Usklajevanje z vizijo in blagovno znamko. Fotografije pripravljene za splet in družbena omrežja. Stranke imajo možnost kombinacije fotografij v samem podjetju, studiju in na terenu. V samem arhivu slik lahko stranke izberejo tudi poljubne panoramske slike iz Sejšelov, San Marina, Toscane, Korzike, Sardinije, Rima, Splita in Dolomitov, ki odlično dopolnijo vsebino spletnih strani.',
  price: '380€',
  image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=2832&auto=format&fit=crop'
}, {
  id: 'centaurus',
  name: 'Centaurus',
  subtitle: 'Dogodki',
  description: 'Reportažno fotografiranje dogodkov. Vključuje fotografijo rojstnodnevnih zabav, poslovnih ali zasebnih dogodkov, ki si jih želite uloviti v objektiv. Čustveni, nasmejani in detaljni trenutki, ki so stisnjeni za spomin. Zaroka in slike na skrito? Ni problema, tudi to! Popolna izbira, kadar boste pogledali galerijo tudi čez nekaj let.',
  price: '400€',
  image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 'cosmos',
  name: 'Cosmos',
  subtitle: 'Poroke',
  description: 'Celovito poročno fotografiranje. Vključuje predporočno svetovanje. Ustvarimo lahko reportažno ali umetniško fotografijo. V primeru večje poroke nad 40 ljudi paket vključuje dva fotografa, da mladoporočencoma za spomin ulovimo vse solze sreče, smeha in seveda prvega poljuba. Paket vsebuje tudi kratko fotografiranje (do 10 slik) pred poroko, da se kot fotograf spoznam z parom in par z mano. Po dogovoru slike lahko dodatno prilagodimo tudi za družbena omrežja. (Slika je simbolična zaradi zasebnosti strank)',
  price: '600€',
  image: 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 'nebula',
  name: 'Nebula',
  subtitle: 'Studijska fotografija',
  description: 'Čista estetika in popoln nadzor svetlobe. Paket vključuje studijsko fotografiranje, čustvene in detaljne posnetke. Po predhodnem dogovoru se prilagodi sam ambient studija. Možno je tudi opremo prinesti na želeno lokacijo. Ker kreativa ne pozna meja lahko v foto studio pripeljemo tudi motor. Skupaj s stranko med fotografiranjem slediva fotografijam, ker je pomembno tudi njeno mnenje in kje se počuti najboljše tisti trenutek. Paket je super izbira tudi za CV ali LinkedIn.',
  price: '350€',
  image: 'https://images.unsplash.com/photo-1604881991720-f91add269bed?q=80&w=2787&auto=format&fit=crop'
}];
export function OfferSection() {
  return <section className="bg-neutral-950 py-16 sm:py-24 px-4 sm:px-6 lg:px-8 border-t border-neutral-900" data-id="element-79">
      <div className="mx-auto max-w-7xl" data-id="element-80">
        {/* Section Header */}
        <div className="mb-16 sm:mb-24 text-center" data-id="element-81">
          <h2 className="text-3xl font-light text-white sm:text-4xl lg:text-5xl" data-id="element-82">
            Fotografska{' '}
            <span className="font-serif italic text-neutral-400" data-id="element-83">ponudba</span>
          </h2>
          <div className="mt-6 h-px w-24 bg-neutral-800 mx-auto" data-id="element-84"></div>
        </div>

        {/* Packages */}
        <div className="space-y-16 sm:space-y-24" data-id="element-85">
          {packages.map((pkg, index) => <div key={pkg.id} className="group grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden bg-neutral-900 border border-neutral-800" data-id="element-86">
              {/* Image Side - Alternates */}
              <div className={`relative aspect-[4/3] lg:aspect-auto overflow-hidden ${index % 2 === 1 ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-87">
                <img src={pkg.image} alt={pkg.subtitle} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-88" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-89" />
              </div>

              {/* Content Side */}
              <div className={`flex flex-col justify-center p-8 sm:p-12 lg:p-16 ${index % 2 === 1 ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-90">
                <div className="mb-6" data-id="element-91">
                  <h3 className="text-2xl sm:text-3xl font-light uppercase tracking-wider text-white mb-2" data-id="element-92">
                    {pkg.name}
                  </h3>
                  <span className="text-xs font-medium uppercase tracking-widest text-neutral-500" data-id="element-93">
                    {pkg.subtitle}
                  </span>
                </div>

                <p className="text-neutral-300 font-light leading-relaxed mb-8 text-sm sm:text-base" data-id="element-94">
                  {pkg.description}
                </p>

                <div className="mt-auto pt-6 border-t border-neutral-800 flex items-baseline justify-between" data-id="element-95">
                  <span className="text-xs uppercase tracking-widest text-neutral-500" data-id="element-96">
                    Začetna cena
                  </span>
                  <span className="text-xl sm:text-2xl font-light text-white" data-id="element-97">
                    {pkg.price}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Footer Note */}
        <div className="mt-16 sm:mt-24 max-w-4xl mx-auto text-center" data-id="element-98">
          <p className="text-xs sm:text-sm text-neutral-500 font-light leading-relaxed" data-id="element-99">
            Paketi vključujejo profesionalno obdelavo fotografij. Cena paketa je
            variabilna, saj vsebuje potne stroške, število ur, ki jih preživimo
            skupaj, tisk ali izdelava drugih fotografskih izdelkov, dodatna
            izbira arhivskih avtorskih slik, itd. Število slik ne vpliva na samo
            ceno paketa. Temu sledi tudi časovni okvir kdaj stranka dobi končno
            podobo slik. Po dogovoru je možno tudi spremljanje stranke več dni
            na samem terenu ali potovanju. Vsem strankam nudimo tudi zlati arhiv
            svojih fotografij v primeru, da jih izgubijo.
          </p>
        </div>
      </div>
    </section>;
}